import React, { useEffect, useState } from "react";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg"
import { useTranslation } from "react-i18next";

import getContentById from "../../../utils/getContentById";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";
import assets from "../../../../frontend/templates/fcb/Goal/assets";
import anime from "animejs";
require("../../../../frontend/templates/fcb/Goal/style/style.scss");

const radius = 14;
const goalRadius = 15;
const width = 550;
const height = 847;

function getCssBottom(x, r = radius) {
    return (x / 100) * height - r;
}

// Convert y (0–100, pitch width) into CSS right
function getCssRight(y, r = radius) {
    return (y / 100) * width - r;
}

// For SVG path drawing
function getSvgX(y, r = radius) {
    return width - getCssRight(y, r) - r;
}

function getSvgY(x, r = radius) {
    return height - getCssBottom(x, r) - r;
}

function getSvgPoint(x, y, r = radius) {
    return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, ...props }) {
    const { t } = useTranslation();

    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;
    const prevRatio = props?.prevRatio;

    const onlyData = data?.data; // data?.data;
    const editData = onlyData?.editData;
    const matchInfo = onlyData?.dynamic?.matchInfo;
    const matchDetails = onlyData?.dynamic?.matchDetails;
    const attackingZones = onlyData?.dynamic?.attackingZones;
    const teamSide = onlyData?.dynamic?.teamSide;
    const goalData = onlyData?.dynamic?.goalData || [];
    const kits = onlyData?.dynamic?.kits;
    const isGoalPenalty = goalData?.isPenalty !== undefined ? goalData?.isPenalty : onlyData?.updater?.isPenalty !== undefined ? onlyData?.updater?.isPenalty : false;
    const competitionId = matchInfo?.competition?.id;

    const matchStatus = matchDetails?.matchStatus;
    const scores = matchDetails?.scores;

    const fields = onlyData?.fields;


    const homeTeam = matchInfo?.contestant?.[0];
    const awayTeam = matchInfo?.contestant?.[1];

    const prepareAnimation = () => {
        prepareVideoBg({ id });
    };

    const goal = goalData?.[goalData?.length - 1];
    const goalPos = goal?.coords?.dest;
    const goalEventId = goal?.eventId;
    const subHeadline = getContentById("subHeadline", fields);
    const selectedMedia1 = getContentById("media1", fields);
    const updater = onlyData?.updater;
    let timeMin = "";
    if (updater) {
        timeMin = updater.timeMin;
    }
    return (
        <div
            id={id}
            className="T_fcb_goal"
        >

            <div className="wc-content wc-content-v2"
                style={{
                    transform: 'scale(0.41)',
                    left: -355,
                    color: 'white'
                }}>
                <div className={`label-container edit`}>
                    <div className="label-match-info-glow edit">BUILD UP PLAY</div>
                    <div className="label-match-info">BUILD UP PLAY</div>
                </div>
                <div className="container">
                    <div className="pitch-container">
                        <div
                            className="pitch"
                            style={{ backgroundImage: `url(${assets.pitch})` }}
                        >

                            {!isGoalPenalty && goalData.map((data) => {
                                return (
                                    <div
                                        className={`circle eventid-${data?.eventId} ${data?.typeId === 16 ? "shooter" : undefined}`}
                                        id={`player-${data?.eventId}-${data?.typeId}`}
                                        key={`${data?.eventId}`}
                                        style={{
                                            bottom: getCssBottom(data?.x),
                                            right: getCssRight(data?.y, radius),
                                            backgroundColor: (data?.isPlayerOpposite || data?.isOwnGoal) ? 'blue' : '#dd0e26',
                                        }}
                                    >
                                        {data?.player?.shirtNumber}
                                    </div>
                                );
                            })}
                            {isGoalPenalty && (
                                <div
                                    className={`circle eventid-${goal?.eventId} ${goal?.typeId === 16 ? "shooter" : undefined}`}
                                    id={`player-${goal?.eventId}-${goal?.typeId}`}
                                    key={`${goal?.eventId}`}
                                    style={{
                                        bottom: getCssBottom(goal?.x),
                                        right: getCssRight(goal?.y, radius),
                                    }}
                                >
                                    {goal?.player?.shirtNumber}
                                </div>
                            )}
                            <img
                                src={assets.ball}
                                className={`circle goal eventid-${goalEventId}`}
                                id={`goal`}
                                style={{
                                    backgroundImage: `url(${assets.ball}`,
                                    bottom: height - goalRadius,
                                    right: getCssRight(goalPos.y, goalRadius),
                                }}
                            ></img>
                            <svg>
                                {goalData.map((data, index, array) => {
                                    const nextPlayer = array[index + 1];

                                    //typeId 16 === Goal
                                    const destRadius =
                                        data.typeId === 16 ? goalRadius : radius;
                                    if (data.typeId === 16) {
                                        return (
                                            <path
                                                id={`path-${data.eventId}-${data.typeId}`}
                                                className={`path event-${data.typeId}`}
                                                key={`${data.x}-${data.y}`}
                                                d={`M${getSvgPoint(data.x, data.y)} ${getSvgX(data.coords.dest.y, destRadius)},0z`}
                                            />
                                        );
                                    }

                                    const pathStyle = {};

                                    // Conditionally add dotted style property
                                    if (data.player?.shirtNumber == nextPlayer?.player?.shirtNumber) {
                                        pathStyle.strokeDasharray = '2, 8';
                                    }
                                    if (!isGoalPenalty) {
                                        return (
                                            <path
                                                id={`path-${data.eventId}-${data.typeId}`}
                                                className={`path event-${data.typeId}`}
                                                key={`${data.x}-${data.y}`}
                                                d={`M${getSvgPoint(data.x, data.y)} ${getSvgPoint(data.coords.dest.x, data.coords.dest.y, destRadius)}z`}
                                                style={pathStyle}
                                            />
                                        );
                                    }
                                })}
                            </svg>
                        </div>
                    </div>
                </div>
                <div className={"bottom-info-container"}>
                    <div className="team-logos-container">
                        <TeamLogo team={homeTeam} competitionId={competitionId} />
                        <TeamLogo team={awayTeam} competitionId={competitionId} />
                    </div>
                    <div className={`player-name`}>
                        MIN {timeMin}'
                    </div>
                </div>
                <div className="gradient"></div>
            </div>
        </div>
    );
}
